import { render } from "./GlobalNotification.vue?vue&type=template&id=cdd4b738&scoped=true"
import script from "./GlobalNotification.vue?vue&type=script&lang=js"
export * from "./GlobalNotification.vue?vue&type=script&lang=js"

import "./GlobalNotification.vue?vue&type=style&index=0&id=cdd4b738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd4b738"]])

export default __exports__